import { useEffect, useState } from "react";

export default function Avatar({ src, name, size = "md", className = "" }) {
  const [imageError, setImageError] = useState(false);

  // If the avatar src changes after a successful upload, we need to retry loading.
  useEffect(() => {
    setImageError(false);
  }, [src]);

  const sizeClasses = {
    sm: "w-10 h-10 text-sm",
    md: "w-16 h-16 text-xl",
    lg: "w-24 h-24 text-3xl",
    xl: "w-32 h-32 text-4xl",
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;

  if (src && !imageError) {
    return (
      <img
        key={src}
        src={src}
        alt={name || "Avatar"}
        className={`${sizeClass} rounded-full object-cover shadow-lg ${className}`}
        onError={() => setImageError(true)}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white font-bold shadow-lg ${className}`}
    >
      {name?.charAt(0).toUpperCase() || "U"}
    </div>
  );
}
